import { NavLink } from "react-router-dom";
import rightArrow from "../../assets/img/right-arrow.png";
import { useTranslation } from "react-i18next";

const Navigation = (props) => {
  const { t } = useTranslation();
  const styles = {
    navStyles: "text-sm font-bold cursor-pointer inline",
  };
  return (
    <div className="inline">
      {props.data?.map((item, i) => {
        return (
          <div className="inline" key={i}>
            <NavLink
              to={item.url}
              className={
                i !== props.data.length - 1
                  ? "text-Dark-Grey " + styles.navStyles
                  : "text-Black dark:text-white " + styles.navStyles
              }
            >
              {t(item.name)}
            </NavLink>
            {i !== props.data.length - 1 && (
              <img
                src={rightArrow}
                alt="Right Arrow"
                className={
                  document.body.dir === "rtl"
                    ? "rotate-180 w-[6px] h-[10px] text-Dark-Grey inline ml-[5px] mr-[5px]"
                    : "w-[6px] h-[10px] text-Dark-Grey inline ml-[5px] mr-[5px]"
                }
              ></img>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Navigation;
